"use client";

import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import AppTheme from "@/styles/AppTheme";

export default function Loading() {
  return (
    <AppTheme>
      <CssBaseline enableColorScheme />
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
          backgroundColor: "background.default",
        }}
      >
        <CircularProgress size={28} />
        <Typography variant="body2" color="text.secondary">
          Loading updated course context...
        </Typography>
      </Box>
    </AppTheme>
  );
}
